import { labelStyles } from '@zapier/style-encapsulation';
import { css, jsx } from '@emotion/react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { Typography } from '../../../theme/Typography.es.js';
import '../../../theme/ZinniaStylesReset.es.js';
import { Avatar } from '../../display/Avatar/Avatar.es.js';
import 'react';
import '../../display/TooltipWrapper/TooltipWrapper.es.js';
import '../../display/Avatar/AvatarGroup.es.js';
import '../../display/Avatar/AvatarsWithText.es.js';
import { remapDeprecatedColors, breakpoints } from './TestimonialMapping.es.js';

const Styles = labelStyles("TestimonialSolo", {
  root: (backgroundColor = "neutral100") => css`
    background-color: ${Colors[remapDeprecatedColors(backgroundColor)]};
  `,
  content: css`
    padding: 39px 19px;
    margin: 0 auto;
    text-align: center;
    max-width: 500px;

    @media screen and (min-width: ${breakpoints.desktop}px) {
      max-width: 770px;
      padding: 58px 0px;
    }
  `,
  avatarContainer: css`
    margin-bottom: 20px;
  `,
  quote: css`
    ${Typography.paragraph3}
    color: ${Colors.neutral800};
    margin-bottom: 20px;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      ${Typography.subHeader1}
    }
  `,
  author: css`
    ${Typography.smallPrint1Bold}
    color: ${Colors.neutral700};

    @media screen and (min-width: ${breakpoints.tablet}px) {
      ${Typography.paragraph3Bold}
    }
  `,
  company: css`
    ${Typography.smallPrint1}
    color: ${Colors.neutral700};

    @media screen and (min-width: ${breakpoints.tablet}px) {
      ${Typography.paragraph3}
    }
  `
});
const TestimonialSolo = ({ backgroundColor, avatarUrl, hasAuthorAvatar = true, quote, author, company }) => {
  return jsx(
    "div",
    { css: Styles.root(backgroundColor), "data-zds": true },
    jsx(
      "div",
      { css: Styles.content, "data-zds": true },
      hasAuthorAvatar && jsx(
        "div",
        { css: Styles.avatarContainer, "data-zds": true },
        jsx(Avatar, { "data-testId": "Avatar", name: author, url: avatarUrl, size: 40 })
      ),
      jsx("div", { css: Styles.quote, "data-zds": true }, quote),
      jsx("p", { css: Styles.author, "data-zds": true }, author),
      jsx("p", { css: Styles.company, "data-zds": true }, company)
    )
  );
};

export { TestimonialSolo };
//# sourceMappingURL=TestimonialSolo.es.js.map
